// extracted by mini-css-extract-plugin
module.exports = {"root":"VolumeSlider_root__ViRH7","grabbing":"VolumeSlider_grabbing__dHtfI"};